import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';

const Checkbox = ({
  label,
  id,
  value = false,
  onChange,
  onBlur = () => {},
  required = false,
  disabled = false,
  dataTest,
  error,
  bottomMarginSizing
}) => {
  const [checked, setChecked] = useState(value);

  let className =
    'border-2 border-grey-200 bg-white shadow-sm hover:border-grey-300 focus:ring-0 focus:ring-transparent focus:border-purple-100 focus:checked:bg-purple-100 hover:checked:border-purple-100 hover:checked:bg-purple-100 checked:bg-purple-100 block w-6 h-6 p-2 rounded-sm font-sans text-base font-normal mt-1 disabled:bg-grey-100 disabled:border-grey-200 disabled:text-grey-400';

  if (Boolean(error)) {
    className = `${className} border-red-100`;
  }

  useEffect(() => {
    setChecked(value);
  }, [value]);

  const handleClick = (evt) => {
    const {
      target: { checked }
    } = evt;
    setChecked(checked);
    onChange(evt);
  };

  return (
    <div
      className={`flex flex-col mt-2 items-start ${
        label || bottomMarginSizing === 0 ? 'mb-0' : bottomMarginSizing === 1 ? 'mb-4' : 'mb-8'
      }`}
    >
      {label ? (
        <label
          htmlFor={id}
          className={`block font-sans text-sm font-bold text-grey-400 ${
            error ? 'text-red-100' : ''
          }`}
          data-testid={`${dataTest}-label`}
        >
          {label}
          {required ? (
            <span
              data-testid={`${dataTest}-label-required`}
              className={error ? 'text-red-100' : 'text-blue-100'}
            >
              *
            </span>
          ) : null}
        </label>
      ) : null}
      <input
        name={id}
        id={id}
        className={className}
        onChange={handleClick}
        onBlur={onBlur}
        type="checkbox"
        checked={checked}
        required={required}
        disabled={disabled}
        data-testid={dataTest}
      />
      {error ? (
        <small
          data-testid={`${dataTest}-error`}
          className="font-medium tracking-wide text-red-500 text-xs mt-1 ml-1"
        >
          {error}
        </small>
      ) : null}
    </div>
  );
};

Checkbox.propTypes = {
  label: PropTypes.string,
  id: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  dataTest: PropTypes.string.isRequired,
  value: PropTypes.bool,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  error: PropTypes.string,
  bottomMarginSizing: PropTypes.oneOf([1, 0, undefined])
};

export default Checkbox;
